import * as StatusBooking from 'src/app/shared/constant/status-booking';
import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Booking } from 'src/app/shared/models/booking/booking';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vehicle-usage-booking-modal',
  imports: [CommonModule, TranslateModule],
  templateUrl: './vehicle-usage-booking-modal.component.html',
  styleUrl: './vehicle-usage-booking-modal.component.scss',
})
export class VehicleUsageBookingModalComponent {
  @Input() booking: Booking;

  constructor(public bsModalRef: BsModalRef) {}

  // private createFakeBookingData(): Booking {
  //   return {
  //     id: 'fake-booking-id',
  //     title: 'Prenotazione di Test',
  //     status: 'OK',
  //     startDate: '2024-05-28T09:00:00.000Z',
  //     endDate: '2024-05-28T17:00:00.000Z',
  //     expectedMileage: 150,
  //     expectedTime: 480,
  //     stages: [
  //       'Ritiro presso sede centrale',
  //       'Visita cliente A - Via Roma 123',
  //       'Riunione ufficio B - Piazza Garibaldi 45',
  //       'Consegna documenti presso notaio',
  //       'Rientro in sede',
  //     ],
  //     extraFields: {
  //       'Numero pratica': 'PR-2024-001',
  //       'Cliente di riferimento': 'Azienda XYZ S.r.l.',
  //       'Note aggiuntive': 'Portare documenti identità',
  //       'Codice autorizzazione': 'AUTH-789456',
  //       'Tipo missione': 'Commerciale',
  //     },
  //     bookingType: {
  //       id: 'bt1',
  //       name: 'BOOKING_TYPE.BUSINESS',
  //       level: 1,
  //       exclusive: false,
  //       uniquePerUser: false,
  //       insertEnabled: true,
  //       ensureDisabled: false,
  //       maxDurationMinutes: 480,
  //       maxEndDateMinutes: 1440,
  //       checkAvailabilityBeforeMinutes: 60,
  //       closeUntakenAfterMinutes: 30,
  //       closeWhenReturned: true,
  //       canTakeDisabledVehicles: false,
  //       enableAlternatives: true,
  //       showMap: true,
  //       titleRequired: false,
  //     },
  //     vehicle: {
  //       id: 'v1',
  //       licensePlate: 'AB123CD',
  //       displayName: 'Volkswagen Golf 2.0 TDI',
  //     },
  //     user: {
  //       id: 'u1',
  //       displayName: 'Mario Rossi',
  //       email: 'mario.rossi@company.com',
  //     },
  //     insertedByUser: {
  //       id: 'u2',
  //       displayName: 'Giulia Bianchi',
  //       email: 'giulia.bianchi@company.com',
  //     },
  //     headquarter: {
  //       id: 'h1',
  //       name: 'Sede Centrale Milano',
  //     },
  //     location: {
  //       id: 'l1',
  //       name: 'Parcheggio Piano Terra',
  //       address: 'Via Milano 100, Milano',
  //     },
  //   };
  // }

  getStatusBooking(): string {
    if (this.booking.status === StatusBooking.STATUS_PENDING) {
      return 'bg-warning';
    }
    if (this.booking.status !== StatusBooking.STATUS_REJECTED) {
      return 'bg-success';
    }

    if (this.booking.status === StatusBooking.STATUS_REJECTED) {
      return 'bg-black';
    }
    return '';
  }
}
